import {
  ENV,
  Environment,
  mockServerPort,
} from '@backoffice-frontend/environment'

const CouponStages = {
  [Environment.local]: `http://localhost:${mockServerPort}/api/payment`,
  [Environment.development]:
    'https://payment-coupon.dev.eu-central-1.api.moia-group.io',
  [Environment.integration]:
    'https://payment-coupon.int.eu-central-1.api.moia-group.io',
  [Environment.production]:
    'https://payment-coupon.prd.eu-central-1.api.moia-group.io',
}

export const CouponAreaEndpoints = {}
CouponAreaEndpoints.Host = CouponStages[ENV]
CouponAreaEndpoints.Base = `${CouponAreaEndpoints.Host}`
CouponAreaEndpoints.Batch = {}
CouponAreaEndpoints.Batch.Create = `${CouponAreaEndpoints.Base}/admin/batch`
CouponAreaEndpoints.Batch.List = `${CouponAreaEndpoints.Base}/admin/batch`
CouponAreaEndpoints.Batch.Update = `${CouponAreaEndpoints.Base}/admin/batch/:couponBatchId/activate`
CouponAreaEndpoints.Batch.Deactivate = `${CouponAreaEndpoints.Base}/admin/batch/:couponBatchId/deactivate`
CouponAreaEndpoints.Batch.DownloadCSV = `${CouponAreaEndpoints.Base}/admin/batch/:couponBatchId/coupons/csv`
